import React from "react";

export default function Loader() {
  return (
    <>
      <div id="loading-wrapper">
        <div id="loading-text">LOADING</div>
        <div id="loading-content"></div>
      </div>
    </>
  );
}
